<template>
  <div class="el-section">
    <dash-receivables-register></dash-receivables-register>
  </div>
</template>

<script>
import '@pagarme/receivables-register/web-comp'

export default {
  name: 'ReceivablesRegisterPage'
}
</script>
